<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1">PAST APPOINTMENTS</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <p class="text-center font-size-15 font-weight-400">
                ENTER PATIENT NAME OR APPOINTMENT DATE
              </p>
            </div>
          </div>
          <br />
          <form [formGroup]="findAppointmentForm">
            <div class="row">

              <div class="col d-flex  col-lg-3 col-md-3 col-sm-12 col-xs-12"></div>

              <div class="dp-hidden position-absolute">
                <div class="input-group">
                  <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    class="calendar1" [autoClose]="'outside'" (dateSelect)="onDateSelection($event, datepicker)"
                    [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1"
                    style="border:0px solid white; color:white !important;" />
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                </div>
              </div>

              <!-- <div class="col-md-3"></div> -->
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <input type="text" class="form-control select" placeholder="Patient Name" name="patName"
                  formControlName="patName" />
              </div>
              <!-- from date start -->




              <div class="col d-flex col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <input class="form-control" placeholder="fromDate" name="findAppointmentForm['fromDate']"
                  [value]="formatter.format(fromDate)"
                  (input)="fromDate = validateInput(fromDate, findAppointmentForm['fromDate'].value)" />
                <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="datepicker.toggle()"
                  type="button"><span class="fa fa-calendar"></span></button>
              </div>
              <!-- from end -->
              <!-- to date -->
              <div class="col d-flex col-lg-2 col-md-2 col-sm-12 col-xs-12 ">
                <input class="form-control" placeholder="To Date" name="appointment['toDate']"
                  [value]="formatter.format(toDate)"
                  (input)="toDate = validateInput(toDate, findAppointmentForm['toDate'].value)" />
                <button class="btn btn-outline-secondary button-height calendar rounded-0" (click)="datepicker.toggle()"
                  type="button"><span class="fa fa-calendar"></span></button>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
              <!-- to date end -->

            </div>
            <br /><br />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" name="find" class="btn btn-primary text-white" (click)="getAppointments()"
                  [disabled]="invalidForm">
                  FIND APPOINTMENT
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="appointments?.length || filterActive">
  <div class="row">
    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <button type="submit" name="find"
                class="btn btn-rounded button-color text-white button-padding mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': !activeBtn }" (click)="getAppointments()">
                ALL
              </button>
              <button type="submit" name="find"
                class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': activeBtn === 'INPERSON' }" (click)="getAppointments('INPERSON', 1)">
                <img src="/assets/images/person.png" class="mr-2" />INPERSON
              </button>
              <button type="submit" name="find"
                class="btn btn-rounded text-white btn-rounded button-color pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': activeBtn === 'ONLINE' }" (click)="getAppointments('ONLINE', 1)">
                <img src="/assets/images/computer.svg" class="mr-2" />ONLINE
              </button>
            </div>
          </div>

          <div class="row" *ngIf="appointments?.length">
            <div class="col-md-12 mt-5 detail-tbl">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" class="w-17 text-center">TYPE</th>
                      <th scope="col" class="w-20">DATE</th>
                      <th scope="col" class="w-20">TIME</th>
                      <th scope="col" class="w-20">PATIENT NAME</th>
                      <th scope="col" class="w-20">CONSULTING DOCTOR</th>
                      <th scope="col">CONSULTATION</th>
                    </tr>
                  </thead>
                  <tr *ngFor="let apt of appointments">
                    <td class="font-size-15">
                      <img src="/assets/images/profile-person.png" class="ml-3 ml-md-5"
                        *ngIf="apt?.apttype == appointmentType.IN_PERSON" />
                      <img src="/assets/images/computer-icon.svg" class="ml-3 ml-md-5"
                        *ngIf="apt?.apttype !== appointmentType.IN_PERSON" />
                    </td>
                    <td class="font-size-15 text-color">
                      {{ apt?.apdate | date: dateFormat }}
                    </td>
                    <td class="font-size-15 text-color">{{ apt?.aptime }}</td>
                    <td class="font-size-15 text-color">
                      {{ apt?.first_name }} {{ apt?.last_name }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ apt?.physician_first_name }}
                      {{ apt?.physician_last_name }}
                    </td>
                    <td *ngIf="
                        apt?.apttype != appointmentType.IN_PERSON &&
                          (!apt?.pid || !apt?.drid || !apt?.aptid);
                        else other_content
                      "></td>
                    <ng-template #other_content>
                      <td>
                        <a class="text-color cursor-pointer" (click)="goToPrescription(apt)">View</a>
                      </td>
                    </ng-template>
                  </tr>
                </table>
                <!-- Pagination -->
                <div class="d-flex">
                  <div class="form-group d-flex mb-0 mr-2">
                    <select class="form-control" [(ngModel)]="pagesize" id="pagesize" (change)="pageChanged()">
                      <option *ngFor="let c of pageCount" value="{{ c }}">
                        {{ c }}
                      </option>
                    </select>
                  </div>
                  <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [pageSize]="pagesize"
                    [rotate]="true" [boundaryLinks]="true" (pageChange)="pageChanged()">
                  </ngb-pagination>
                  <div class="ml-2 line-h-36">
                    Total rows : {{ collectionSize }}
                  </div>
                </div>
                <!-- ./ Pagination -->
              </div>
            </div>
          </div>

          <div class="row" *ngIf="!appointments?.length && !filterActive">
            <div class="col-lg-12 mt-2 text-center">
              <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="!appointments?.length && noAppointments">
  <div class="card m-b-30">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
        </div>
      </div>
    </div>
  </div>
</div>